module.exports = __webpack_public_path__ + "static/media/how_to_3.09d6f655.svg";